/**
 * 导入工具类
 */
import { bridgeCallHandler } from '../../core';
import { printNativeMethodFallback } from '../../internal';
import { isInApp } from '../../utils';

/**
 * 导入类型声明
 */
import type { LiveCollectionChangedOptions, NativeLiveOptions, OpenCkLiveOptions } from '../../types';

/**
 * 打开创客直播
 * @param data
 * @returns
 */
export const openLiveUrl = (data: OpenCkLiveOptions): void => {
  const isApp: boolean = isInApp();

  if (!isApp) {
    printNativeMethodFallback('openLiveUrl', 'openLiveUrl');
    return;
  }

  const params: string = JSON.stringify(data);
  bridgeCallHandler('openLiveUrl', params, null);
};

/**
 * 打开原生直播
 */
export const openNativeLive = (data: NativeLiveOptions): void => {
  if (!isInApp()) {
    printNativeMethodFallback('openNativeLive', 'openNativeLive');
    return;
  }
  const params = JSON.stringify(data);
  bridgeCallHandler('openNativeLive', params, null);
};

/**
 * 通知客户端直播收藏状态变更
 */
export const liveCollectionChanged = (data: LiveCollectionChangedOptions): void => {
  if (!isInApp()) {
    printNativeMethodFallback('liveCollectionChanged', 'liveCollectionChanged');
    return;
  }
  const params = JSON.stringify(data);
  bridgeCallHandler('liveCollectionChanged', params, null);
};

/**
 * 获取小鹅通直播地址
 * @date 2023-07-07
 */
export const getXetLiveUrl = (callback: (liveUrl: string) => void): void => {
  const isApp: boolean = isInApp();
  if (!isApp) {
    printNativeMethodFallback('getXetLiveUrl', 'getXetLiveUrl');
    return;
  }
  bridgeCallHandler('getXetLiveUrl', '', callback);
};
